// libs
import { useMutation } from '@apollo/client/react'
// graphql
import { REVIEW_APPROVE_MUTATION } from 'graphql/reviews/mutations'
// types
import { IReview } from 'types/graphql'
// utils
import { handleError } from 'utils/errors/handlers'
import { getRefetchQueriesForReviews } from 'utils/reviews'

export const useApproveReview = () => {
  const [reviewApproveMutation, { loading: isApproving }] = useMutation(REVIEW_APPROVE_MUTATION)

  // resolves to false when the mutation failed, so callers can keep their view open
  const approveReview = async (review: Pick<IReview, 'id'>, entity): Promise<boolean> => {
    try {
      await reviewApproveMutation({
        variables: { id: review.id },
        refetchQueries: getRefetchQueriesForReviews(entity),
        // marks the cached review approved, so every "to approve" list (e.g. reviewsToApprove) drops it right away
        update: (cache) => {
          cache.modify({
            id: cache.identify({ __typename: 'Review', id: review.id }),
            fields: { approvedAt: () => new Date().toISOString() }
          })
        }
      })

      return true
    } catch (error) {
      handleError(error, 'useApproveReview.approveReview')

      return false
    }
  }

  return { approveReview, isApproving }
}
